import { css } from '@emotion/react'
import Label from '../Label'
import Row from '../IndentedRow'
import Dropdown from './Dropdown'

const flexStyle = css`
  flex: 1 0 100%;
`

const FromRow = ({
  className,
  mailbox,
  mailboxId,
  mailboxes,
  onMailboxClick,
}) => {
  let currentMailbox = mailbox
  if (mailboxId) currentMailbox = mailboxes.find(m => m.id === mailboxId)
  return (
    <Row css={flexStyle} className={className}>
      <Label>From:</Label>
      <Dropdown
        mailbox={currentMailbox}
        mailboxes={mailboxes}
        onClick={onMailboxClick}
        className="grui ml-3"
      />
    </Row>
  )
}

export default FromRow
